import React from 'react';
import LayoutCustomerSuccess from 'src/components/LayoutCustomerSuccess/LayoutCustomerSuccess';
import Retention from 'src/components/Retention/Retention';

const RetentionPage = () => (
    <LayoutCustomerSuccess>
        <Retention />
    </LayoutCustomerSuccess>
);

export default RetentionPage;
